import React, { useState } from 'react';
import { Text, TabsContext, TabList, Tab, TabPanel, TabPanels } from '@vibe/core';
import PermissionRulesTab from './PermissionRulesTab';
import TimesheetViewersTab from './TimesheetViewersTab';

const TimesheetPermissionsPanel: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="rp-timesheet-permissions">
      <div className="rp-timesheet-permissions__header">
        <Text
          type={Text.types.TEXT2}
          style={{ color: '#676879', marginBottom: 4, whiteSpace: 'normal', overflow: 'visible', textOverflow: 'unset' }}
        >
          <strong>Approvers</strong> see (and can approve) timesheets of users
          they are assigned to — scoped by approver/approvee mapping. {' '}
          <strong>Viewers</strong> see every timesheet in the account without
          approval rights. A user can be both: adding an approver to the Viewers
          list grants them global view access in addition to approver rights.
          Admins always have full access.
        </Text>
      </div>

      <TabsContext activeTabId={activeTab}>
        <TabList onTabChange={(tabId) => setActiveTab(tabId)}>
          <Tab>Approvers</Tab>
          <Tab>Viewers</Tab>
        </TabList>

        <TabPanels activeTabId={activeTab}>
          <TabPanel>
            <div style={{ paddingTop: 20 }}>
              <PermissionRulesTab
                permission="timesheet_approve"
                granteeLabel="Approver(s)"
              />
            </div>
          </TabPanel>

          <TabPanel>
            <div style={{ paddingTop: 20 }}>
              <TimesheetViewersTab />
            </div>
          </TabPanel>
        </TabPanels>
      </TabsContext>
    </div>
  );
};

export default TimesheetPermissionsPanel;
